import { Injectable } from '@angular/core';
import { ConnectableObservable, Subject, Subscription, concat } from 'rxjs';
import { map, publishReplay } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Settings } from '../core/settings';
import { deserialize, dataMember } from 'santee-dcts';

@Injectable()
export class TermsAcceptanceStorage {
    private readonly termsAcceptedSource = new Subject<boolean>();

    private readonly mergedStream: ConnectableObservable<boolean>;

    private readonly endpointUrl: string;

    private subs: Subscription;

    constructor(private http: HttpClient, private settings: Settings) {
        this.endpointUrl = `${settings.apiUrl}/terms-acknowledgement`;

        const termsAcknowledgement = this.http
            .get(this.endpointUrl)
            .pipe(
                map(x => deserialize(x, TermsAcknowledgement).termsAcknowledged)
            );

        this.mergedStream = concat(termsAcknowledgement, this.termsAcceptedSource).pipe(publishReplay(1)) as ConnectableObservable<boolean>;
        this.subs = this.mergedStream.connect();
    }

    public get areTermsAccepted() {
        return this.mergedStream;
    }

    public async acceptTerms() {
        this.termsAcceptedSource.next(true);
        this.subs.unsubscribe();

        await this.http
            .post(this.endpointUrl, {})
            .toPromise();
    }
}

export class TermsAcknowledgement {
    @dataMember()
    public termsAcknowledged: boolean;
}